import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';
import VideoWaterfall from '@/components/feature/VideoWaterfall';

export default function RecommendedSection() {
  const [active, setActive] = useState('all');

  const list = active === 'all' ? videos : videos.filter((v) => v.category === active);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100/60">
      <div className="flex items-end justify-between mb-6 gap-4 flex-wrap">
        <div>
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950">为你推荐</h2>
          <p className="text-sm text-foreground-500 mt-1.5">根据你的兴趣，精选了这些精彩短视频</p>
        </div>
      </div>

      {/* 分类切换 */}
      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1 mb-6">
        <button
          type="button"
          onClick={() => setActive('all')}
          className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
            active === 'all'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
          }`}
        >
          全部
        </button>
        {categories.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => setActive(c.key)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer flex items-center gap-1.5 ${
              active === c.key
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
            }`}
          >
            <i className={`${c.icon} text-base`}></i>
            {c.name}
          </button>
        ))}
      </div>

      <VideoWaterfall videos={list} />

      <div className="mt-6 flex justify-center">
        <Link
          to="/search"
          className="inline-flex items-center gap-2 h-11 px-7 rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          探索更多内容
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}